export const getForeignPaidCt = (paidCt: number, exchangeRate: number) => {
    return (Math.round((exchangeRate * paidCt) * 100) / 100)
}
